import { Component, Input, Output, EventEmitter, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { Localization } from '../../app/app.localization';
import { Storage } from '@ionic/storage';
import { Broadcaster } from '../../app/broadcaster';

/**
 * Generated class for the HeaderCartComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'header-cart',
  templateUrl: 'header-cart.html'
})
export class HeaderCartComponent {

  hidden: boolean;
  isFixedLayout: boolean = false;
  storeName: string;

  @ViewChild('indexMenu') indexMenu: ElementRef;
  @Input() iTotal:number;
  @Input() indexes:any;
  @Output() public goCart = new  EventEmitter<any>();

  /**
   * constructor
   * @param _loc 
   * @param storage 
   * @param broadcaster 
   */
  constructor(
    private _loc: Localization,
    private storage: Storage,
    private rd: Renderer2,
    private broadcaster: Broadcaster
  ) {
    let configs = JSON.parse(localStorage.getItem("configs"));
    if (configs['MOBILEORDER_FIXED_LAYOUT'] == 1) this.isFixedLayout = true;
    this.init();
  }

  /**
   * async 初期化
   */
  async init(){
    this.iTotal = 0;
    this.storeName = localStorage.getItem("storeName");
  }

  /**
   * カートをタップ
   */
  tapCart(){
    this.goCart.emit({});
  }

  /**
   * メニューカテゴリをタップ
   */
  openIndexMenu(){
    this.rd.removeClass(this.indexMenu.nativeElement, "index_menu_hide");
    this.rd.addClass(this.indexMenu.nativeElement, "index_menu_show");
  }

  /**
   * メニューカテゴリの閉じるをタップ
   */
  closeIndexMenu(){
    this.rd.removeClass(this.indexMenu.nativeElement, "index_menu_show");
    this.rd.addClass(this.indexMenu.nativeElement, "index_menu_hide");
  }

  /**
   * インデックスをタップ
   * @param idx 
   */
  selectIndex(idx){
    if (idx.onTap){
      idx.onTap(idx);
    }
    this.closeIndexMenu();
  }
}



// WEBPACK FOOTER //
// ./src/components/header-cart/header-cart.ts